import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const ElectricalGoodsDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="Electrical Goods"
      sectionId="electrical-goods"
      sectionKey="Electrical Goods"
      description="Electrical Equipment Inventory"
      backRoute="/"
    />
  );
};

export default ElectricalGoodsDashboard;
